<template>
    <div class="p-0">
        <div v-if="isQrFeatureVisible">
            <div class="font-color-171717">
                <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
                    <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;">
                        <CRow class="m-2">
                            <CCol sm="12">
                                <h3 class="custom-40px-500 text-center mt-3">For Marketing Purpose</h3>
                            </CCol>
                            <CCol sm="12">
                                <CRow>
                                    <CCol sm="10">
                                        <CInput type="text" placeholder="Search..." v-model="searchQuery" />
                                    </CCol>
                                    <CCol sm="2" style="margin-top:-30px;">
                                        <label for="itemsPerPage" class="p-0">Items per page:</label>
                                        <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                            <option value="10">Show 10</option>
                            <option value="20">Show 20</option>
                            <option value="50">Show 50</option>
                            </select>
                                    </CCol>
        
                                </CRow> 
                                <template v-if="Busy == true">
                                    <div class="container text-center">
                                    <pulse-loader
                                        :loading="loading"
                                        :color="color"
                                        :size="size"
                                    ></pulse-loader>
                                    </div>
                                    </template>

                                    <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredList" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">

                                    <template #Code="{ item }">
                                        <td>
                                            {{ item.code }}
                                        </td>
                                    </template>

                                    <template #URL="{ item }">
                                        <td>
                                            <a :href="`https://app.interviewrr.ai/directinterview?code=${item.code}`" target="_blank">
                                            https://app.interviewrr.ai/directinterview?code={{ item.code }}
                                        </a>
                                        </td>
                                    </template>

                                    <template #Specifications="{ item }">
                                        <td>
                                            {{ item.job }}
                                        </td>
                                    </template>

                                    <template #Action="{ item }">
                                        <td>
                                            <label class="custom-border-purple p-20 b-20 text-white" @click="OpenQr(item.code)"><span class="mr-3 ml-3">Share QR</span></label>
                                            <!-- <label class="custom-border-purple p-20 b-20 text-white" @click="OpenUpdate(item.Id, item.job, item.positionCode)"><span class="mr-3 ml-3">Edit</span></label>
                                            <img src="../assets/img/delete.png" @click="OpenDelete(item.Id, item.job)" style="max-width:30px" class="ml-2"> -->
                                        </td>
                                    </template>

                                    </CDataTable>

                            
                            </CCol>
        
                        </CRow>
                    </CCard>
                    <br /><br /><br />
                </div>
                <div v-if="isPopupQR" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <div class="text-right">
                    <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                </div>
                    <!-- Popup content -->
                    <div class="text-center">
                        <img :src="qrCodeUrl" alt="QR Code" style="max-width:100%">
                        <h1 class="font-general-sans text-center custom-18px-600">
                            How to Share Your QR Code:
                                </h1>
                            <h4 class="custom-14px-400">Copy the QR code image by clicking the 'Copy QR' button. <br />
    Paste and share the QR code image via email, messaging apps, or any other preferred method.
    </h4>
                        <CButton class="custom-border-purple mt-4 text-white"  @click="copyQRCode" style="width:100px">
                            <span class="ml-2 mr-2">Copy QR</span>
                        </CButton>
                    </div>
                </div>
            </div>
            </div>
        </div>
        <div v-else>
            <div v-if="isPopupError">
                <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 100px" src="../assets/img/error.png" />
                            <h3 class="custom-32px-500 text-center mt-3 font-color-171717">
                               Ooops!
                            </h3>
                            <h3 class="custom-18px text-center mt-3">
                                You don’t have permission to access this page. Please contact your administrator or check your account settings.
                            </h3>
                        </div>
        
                    </div>
            </div>
            <br /> <br /> <br />
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import QRCode from 'qrcode-generator';
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartDoughnut } from '@coreui/vue-chartjs';
import { CCol } from '@coreui/vue';
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");
import _ from "lodash";
import { CChartRadar } from '@coreui/vue-chartjs'

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        PulseLoader,
        CChartDoughnut,
        CCol,
        CChartRadar
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            ispopupVisible2: false,
            ispopupVisible3: false,
            quesList: [],
            user: {},
            currentPage: 1,
            itemsPerPage: 10,
            searchQuery: "",
            fields: [{
                    key: 'Code'
                }, {
                    key: 'URL'
                },
                {
                    key: 'Specifications'
                },
                {
                    key: 'Action'
                },
            ],
            srcUrl: "",
            qrCodeUrl: "",
            isPopupQR: false,
            features:[],
            isPopupError: true,
            Busy:false

        };
    },
    created() {},
    computed: {
        filteredList() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            // Check if quesList is an array
            if (!Array.isArray(this.quesList)) {
                return [];
            }

            const today = new Date().toISOString().split('T')[0]; // Get today's date in 'YYYY-MM-DD' format

            const filtered = this.quesList
                .filter(item => {
                    const codeValid = item.code !== "Not generated yet.";
                    const validDateValid = item.validDate && item.validDate >= today;

                    return codeValid && validDateValid;
                })
                .filter(item => {
                    const job = item.job || ''; // Ensure item.job is a string
                    const code = item.code || '';
                    const matchesQuery = query ? job.toLowerCase().includes(query) || code.toLowerCase().includes(query) : true;

                    // Include only jobs with the title "Surveying"
                    return job.toLowerCase() === 'surveying' && matchesQuery;
                });

            return filtered;
        },
        isQrFeatureVisible() {
            // Check if the user has access to the Blog feature in the "Page" group
            return Array.isArray(this.features) && this.features.filter(f => f.FeaturesGroup === "Page" && f.FeaturesType === "QR" && f.IsVisible).length > 0;
        }

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser(); // Fetch the user details first
                await this.getListInterview();
                this.getFeatures();

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async getListInterview() {
            this.Busy = true;
            try {
                const response = await this.$API.get(
                    `${this.$ListCreatedQuestion}`, {
                        withCredentials: true,
                    }
                );
                if (response.status === 200) {
                    this.Busy = false;
                    this.quesList = response.data;
                } else {

                }
            } catch (error) {}

        },


        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        OpenQr(jobCode) {
            this.jobCode = jobCode;
            this.qrCodeUrl = "https://app.interviewrr.ai/directinterview?code=" + this.jobCode;
            this.generateQRCode(this.qrCodeUrl);
            this.isPopupQR = true;
        },
        async copyQRCode() {
      try {
        // Create an offscreen canvas to copy the QR code image
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const img = new Image();

        img.src = this.qrCodeUrl;
        img.onload = () => {
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0);
          
          canvas.toBlob(async (blob) => {
            try {
              await navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]);
              alert('QR code image copied to clipboard!');
            } catch (err) {
              console.error('Failed to copy image: ', err);
            }
          }, 'image/png');
        };
      } catch (error) {
        console.error('Error copying QR code:', error);
      }
    },
        generateQRCode(qrValue) {
            const qr = QRCode(0, 'L');
            qr.addData(qrValue);
            qr.make();
            this.qrCodeUrl = qr.createDataURL(6); // 6 is the scale factor, you can adjust as needed
        },
        closePopup()
        {
            this.isPopupQR = false;
        },
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },



    }

};
</script>
